// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__I5GnP","unreadBadge":"styles_unreadBadge__23RIb","modalContent":"styles_modalContent__1JibI","modal":"styles_modal__1eUvZ"};